import getBoldedText from "@insite/client-framework/Common/Utilities/getPatternBolded";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import {
    OrderHistoryAutocompleteApiParameter,
    orderHistoryAutocompleteSearch,
} from "@store/Services/OrderHistoryAutocompleteService";
import { OrderHistoryResultsModel } from "@store/Types/ApiModels";

type Parameter = { query: string };

type Props = {
    apiParameter: OrderHistoryAutocompleteApiParameter;
    apiResult: any;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginSearchOrderHistoryProducts: HandlerType = props => {
    const dispatch: any = props.dispatch;
    dispatch({
        type: "Components/OrderHistoryProductSelector/BeginSearchOrderHistoryProducts",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    if (props.parameter.query.length > 0) {
        const results = await orderHistoryAutocompleteSearch(props.apiParameter);
        if (results) {
            props.apiResult = results;
        }
    }
};

export const SetDisplayTitles: HandlerType = props => {
    if (props.apiResult) {
        props.apiResult.forEach((product: OrderHistoryResultsModel) => {
            product.displayTitle = getBoldedText(product.autocompleteItemModel.title, props.apiParameter.query);
            product.displayErpNumber = getBoldedText(product.autocompleteItemModel.erpNumber, props.apiParameter.query);
        });
    }
};

export const DispatchCompleteSearchOrderHistoryProducts: HandlerType = props => {
    const dispatch: any = props.dispatch;
    dispatch({
        type: "Components/OrderHistoryProductSelector/CompleteSearchOrderHistoryProducts",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginSearchOrderHistoryProducts,
    PopulateApiParameter,
    RequestDataFromApi,
    SetDisplayTitles,
    DispatchCompleteSearchOrderHistoryProducts,
];

const searchOrderHistoryProducts = createHandlerChainRunnerOptionalParameter(
    chain,
    { query: "" },
    "SearchOrderHistoryProducts",
);
export default searchOrderHistoryProducts;
